import { CouplePatientAPI, listAllTherapistPatientsResponse } from "../../patient";

/** The therapist's individual patients a session can be booked with (first 200). */
export async function listSchedulerPatients(therapistId: string) {
    const { data } = await listAllTherapistPatientsResponse(therapistId);
    return data.patients;
}

/** The therapist's couples a session can be booked with. */
export async function listSchedulerCouples(therapistId: string) {
    const { data } = await CouplePatientAPI.listByTherapist(therapistId);
    return data;
}
